import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ColorModeProvider } from './contexts/ColorModeContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyAccount from './pages/VerifyAccount';
import Profile from './pages/Profile';
import PasswordChange from './pages/Profile/PasswordChange';
import FirstTimeLogin from './pages/FirstTimeLogin';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import ProtectedRoute from './components/auth/ProtectedRoute';

function App() {
  return (
    <ColorModeProvider>
      <AuthProvider>
        <SubscriptionProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/first-time-login" element={<FirstTimeLogin />} />
              <Route path="/register" element={<Register />} />
              <Route path="/verify-account" element={<VerifyAccount />} />
              <Route path="/services" element={<Services />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route 
                path="/profile" 
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/profile/emergency-contacts" 
                element={<Navigate to="/profile" replace state={{ tab: 1 }} />} 
              />
              <Route 
                path="/profile/change-password" 
                element={
                  <ProtectedRoute>
                    <PasswordChange />
                  </ProtectedRoute>
                } 
              />
            </Routes>
          </Router>
        </SubscriptionProvider>
      </AuthProvider>
    </ColorModeProvider>
  );
}

export default App;
